export const ANIMAL_ALERT_TYPES = ['Chaos!', 'Eeeek!', 'Get a room!'] as const;

export type AnimalAlertType = (typeof ANIMAL_ALERT_TYPES)[number];

export const ANIMAL_ALERT_COOLDOWN_MS = 60_000;

export const ANIMAL_ALERT_GRADIENTS: Record<AnimalAlertType, string> = {
  'Chaos!': 'linear-gradient(135deg, #FF6A25 0%, #FF9B05 100%)',
  'Eeeek!': 'linear-gradient(135deg, #F18C43 0%, #F9A5E7 100%)',
  'Get a room!': 'linear-gradient(135deg, #CDD565 0%, #73FF95 100%)',
};
